import { useEffect, useState } from 'react'
import * as Sentry from '@sentry/browser';

// El SDK de Incode no se carga correctamente si se
// carga desde la etiqueta script, por lo que se carga dinamicamente
// -----------------------------------------------------------------
const INCODE_SDK_SRC = 'https://sdk.incode.com/sdk/onBoarding-1.55.0.js'
const INCODE_SDK_SELECTOR = 'script[src*="onBoarding-1.55.0.js"]'
let incodeSDKLoadPromise = null

function ensureIncodeSDKLoaded() {
  if (window.OnBoarding) {
    return Promise.resolve()
  }

  if (incodeSDKLoadPromise) {
    return incodeSDKLoadPromise
  }

  incodeSDKLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(INCODE_SDK_SELECTOR)

    if (existingScript) {
      const onLoad = () => {
        existingScript.removeEventListener('load', onLoad)
        existingScript.removeEventListener('error', onError)
        resolve()
      }

      const onError = (error) => {
        existingScript.removeEventListener('load', onLoad)
        existingScript.removeEventListener('error', onError)
        incodeSDKLoadPromise = null
        reject(error)
      }

      if (window.OnBoarding || existingScript.readyState === 'complete') {
        resolve()
        return
      }

      existingScript.addEventListener('load', onLoad)
      existingScript.addEventListener('error', onError)
      return
    }

    const script = document.createElement('script')
    script.src = INCODE_SDK_SRC
    script.async = true

    script.addEventListener('load', () => resolve())
    script.addEventListener('error', (error) => {
      incodeSDKLoadPromise = null
      reject(error)
    })

    document.body.appendChild(script)
  })

  return incodeSDKLoadPromise
}

export function useIncodeSDK() {
  const [isLoadedSDK, setIsLoadedSDK] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    let isMounted = true

    ensureIncodeSDKLoaded()
      .then(() => {
        if (isMounted) {
          setIsLoadedSDK(true)
          setError(null)
        }
      })
      .catch((sdkError) => {
        const errorMessage = 'Error loading Incode SDK'
        if (isMounted) {
          setError(new Error(errorMessage))
        }
        console.error(errorMessage, sdkError)
        Sentry.captureException(errorMessage, {
          extra: {
            error: sdkError
          }
        })
      })

    return () => {
      isMounted = false
    }
  }, [])

  return { isLoadedSDK, error }
}
